import { Navigate, Outlet } from "react-router-dom";
import Navbar from "../_components/common/Navbar";



const ProtectedRoutesOutlet = () => {
  
  const auth = { token: localStorage.getItem('access_token_AS') };
  const status = localStorage.getItem('ACCOUNT_STATUS')
  
  // const auth = { token: "Authenticated" };
  // const auth = { token: null };


  return auth.token  ? (
    <>
      {/* Header | Footer | Drawer for Protected Routes add here */}
      <header >
         
        <Navbar />
      
      </header>
      <Outlet />
    </>
  ) : (
    <Navigate to="/login" />
  );
};

export default ProtectedRoutesOutlet;
